import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './ContemporaryLandingCategoriesTab.scss';

export const ContemporaryLandingCategoriesTab = ({ index, isSelected, setTabIndex, tab }) => {
    const navCategoryClasses = classnames(styles.navCategory, {
        [styles.isSelected]: isSelected,
    });
    return (
        <div className="colXs4" onClick={() => setTabIndex(index, tab.name)}>
            <p className={navCategoryClasses}>{tab.name}</p>
        </div>
    );
};

ContemporaryLandingCategoriesTab.propTypes = {
    index: PropTypes.number,
    isSelected: PropTypes.bool,
    setTabIndex: PropTypes.func,
    tab: PropTypes.object,
};
